import Vue from 'vue';
import Vuex from 'vuex';
import web1_request from 'Repo/web1-request';
import util from '@/util';

// eslint-disable-next-line
import mock from 'MOCK';

// Globally set the client id for http wr requests.
// web1_request.set_client_id( window.Server.config.session.client.clientid );

Vue.use(Vuex);

const store = new Vuex.Store({
   state: {
      server: window.Server,
      attempts: window.Server.config.attempts,
      error: window.Server.config.error,
      dashboard: window.Server.config.dashboard,
      problem: null,
      success: [],
      wait: null,
      page_title: null,
      username: '',
      password: '',
      max_attempts: 7,
      message_too_many_logins: 'Too many failed login attempts. You will be blocked from attempting again for 24 hours.'
   },
   mutations: {
      ADD_SUCCESS ( state, c_message ) {
         state.success.push( c_message );
      },// /ADD_SUCCESS()

      CLEAR_SUCCESS ( state ) {
         state.success.splice( 0, state.success.length );
      },// /CLEAR_SUCCESS()

      SET_SHOW ( state, { error, problem, wait } ){
         state.error = error;
         state.problem = problem;
         state.wait = wait;
      },// /SET_SHOW()

      SET_PAGE_TITLE ( state, c_title ){
         state.page_title = c_title;
      },// /SET_PAGE_TITLE()

      INCREMENT_ATTEMPTS ( state ){
         state.attempts = state.attempts + 1;
      },// /INCREMENT_ATTEMPTS()

      
   },// /mutations{}


   actions: {
      add_success_message (context, message){
         context.commit( 'ADD_SUCCESS', message );
      },


      clear_success_messages (context, message){
         context.commit( 'CLEAR_SUCCESS', message );
      },

      set_message ( context, { type, message } ){
         const o_state = {
            error: null,
            problem: null,
            wait: null
         };

         if( !o_state.hasOwnProperty( type ) ){
            throw new Error( `Invalid message type "${type}".` );
         }

         o_state[ type ] = message;
         context.commit( 'SET_SHOW', o_state );
      },// /set_message()

      clear_messages ( context ){
         context.commit( 'SET_SHOW', {
            error: null,
            problem: null,
            wait: null
         } );
      },// /clear_messages()

      set_page_title ( context, c_title ){
         context.commit( 'SET_PAGE_TITLE', c_title );
      },

      login_session( context, o_credentials ){
         const c_name = 'loginsession';

         return new Promise(function( resolve, reject ){

            const o_data = util.object_pick( o_credentials, [
               'username',
               'password'
            ] );

            web1_request({
               method: 'post',
               wr: c_name, 
            data: o_data
            })
            .send()
            .then(([o_error, o_result, c_name]) => {
               var o_result_error;

               // Check for to see if the request was completed and that a
               // valid JSON response was received.
               if (o_error) {
                  // An error happend that either failed to recognize the
                  // response or we never reached the server at all.
                  o_result_error = {
                     code: 500,
                     message: c_name.concat( ' Failure: ', o_error.message )
                  };
                  //context.dispatch( 'set_message', { type:'error', message: });
                  return reject( o_result_error );
               }// /if()


               // The server received our request and provided us with a valid JSON
               // response. Now we check if the web1 server's response contains an error 
               // message.
               if (o_result.error) {
                  // The server sent us an error message. Display the message to the user.
                  o_result_error = {
                     code: 500,
                     message: c_name.concat( ' Error: ', o_result.error.message )
                  };
                  context.commit( 'INCREMENT_ATTEMPTS' );
                  if( context.state.attempts >= context.state.max_attempts ){
                     return reject({
                        code: 409,
                        message: context.state.message_too_many_logins
                     });
                  }
                  return reject( o_result_error );
               }

               // At this point the server has provided us with the data we asked for.
               return resolve( o_result );
            })
            .catch(( o_error ) => {
               // This can happend when web1 randomly returns a "no output" html error.
               const o_result_error = {
                  code: 500,
                  message: c_name.concat(' Failed: ', o_error.message )
               };
               return reject( o_result_error );
            });
         });
      },// /login_session()
   },// /actions{}

   getters: {
      
      error ( state ){
         return state.error;
      },
      
      problem ( state ){
         return state.problem;
      },
      
      wait ( state ){
         return state.wait;
      },
      
      success ( state ){
         return state.success;
      },
      
      no_blocking_errors ( state ){
         return !state.error && !state.problem && !state.wait;
      },
      
      no_blocking_alerts ( state ){
         return !state.error && !state.problem && !state.wait && state.success.length == 0;
      },
      
      page_title ( state ){
         return state.page_title;
      },
      
      attempts ( state ){
         return state.attempts;
      },
      
      max_attempts ( state ){
         return state.max_attempts;
      },
      
      message_too_many_logins ( state ){
         return state.message_too_many_logins;
      },
      
      show_dashboard ( state ){
         return state.dashboard;
      },

      
      

      
   },// /getters()

   // plugins: [
   //    function( store ){
   //       store.subscribe((mut, state) => {
   //          console.log( 'mut', mut );
   //          console.log( 'state', state );
   //       });
   //    }
   // ]
});

export default store;
